import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('creative', { creative: 'currentCreative' }),
  },
};



// WEBPACK FOOTER //
// ./src/components/lab/creative-heading/CreativeHeading.js